// eslint-disable-next-line no-unused-vars
import { numeral } from '@fund/basic-lib';
import { market as config } from '../config';
import p from './public';
// 格式化'%'时不自动除100
numeral.options.scalePercentBy100 = false;

// 市场行情（走势图）- 金价走势
export default {

  // 格式化数据
  formatData: (row) => {
    let data = [];
    // eslint-disable-next-line array-callback-return
    row.Datas.map(({ PDATE, PERCENTPRICE, CHGRT }, index) => {
      data = data.concat([
        {
          date: PDATE,
          type: '金价',
          value: PERCENTPRICE - 0,
          rise: CHGRT - 0,
          index,
          max: row.Datas.length,
        },
      ]);
    });

    return data;
  },

  // 绘制走势图
  drawChart(data, chart, changeSlideState, setLegend) {
    // 创建十字线组件
    const {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    } = p().createToolTipsList(chart);
    const toolTipsList = {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    };

    // 绘制走势图
    chart.source(data, p().sourceConfig);

    // 水印
    p().drawLogo(chart);

    chart.scale('value', {
      nice: true,
      max: p().getMaxVal(data),
    });

    chart.legend(false);

    chart.tooltip({
      ...p().tooltipConfig,
      yTip(val) {
        return {
          ...p().yTipsConfig,
          text: numeral(val).format('0.00', Math.trunc),
        };
      },
      onChange: (obj) => {
        p().tooltipOnChange();
        changeSlideState(true);

        const point = obj.items[0].origin;
        setLegend([
          point.date, // 0 日期
          point.value, // 1 金价
          point.rise, // 日涨幅
        ]);

        // 显示十字线
        p().showToolTips(
          toolTipsList,
          obj.items[0],
          (val) => numeral(val).format('0.00', Math.trunc),
        );
      },
      onHide: () => {
        p().tooltipOnHide();
        changeSlideState(false);

        // 隐藏十字线
        p().hideToolTIps(toolTipsList);
      },
    });

    chart.axis('value', {
      ...p().yAxisGridConfig,
      label: function label(text) {
        const cfg = {
          ...p().yAxisConfig,
          text: numeral(text).format('0.00', Math.trunc),
        };
        return cfg;
      },
    });

    chart.axis('date', {
      ...p().xAxisGridConfig,
      label: function label(text, index, total) {
        let textCfg = {
          text: text.substring(5),
        };
        if (index === 0) {
          textCfg.textAlign = 'left';
        } else if (index === total - 1) {
          textCfg.textAlign = 'right';
        } else {
          textCfg = null;
        }
        return textCfg && { ...p().xAxisConfig, ...textCfg };
      },
    });

    chart.line().position('date*value').color('type', config.colors).size(2)
      .animate(false);

    chart.render();
  },
};
